/**
 * This is the main JavaScript entrypoint for the Maps show page
 */

import Washi from 'washi'
import Map from '../../src/map/components/map-show'

Washi(Map, {
  el: '#map-outer',
  lockBoundaries: true,
  routes: window.mapPlaces
})
